var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100"},[(_setup.isLoading)?_c(_setup.Loader):[_c(_setup.ReportExportsForm,{attrs:{"save-button-label":_vm.$t('reportExports.save'),"mode":"edit"},on:{"save":_setup.save}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }